export class MessageConstant {
    public static PAYMENT_SUCCESS = 'Payment Success!';
    public static PAYMENT_FAILED = 'Payment Failed!';
    public static NOT_FOUND = 'Transaction Not Found!';
    public static INVALID_BILL_OR_VIRTUAL_ACCOUNT_NOT_FOUND = 'Invalid Bill/Virtual Account not found';
    public static ALREADY_PAID = 'VA Number Already Paid!';
    public static CANNOT_PROCESS = 'Sorry Your Transaction Cannot be Processed!';
    public static ON_PROCESS = 'Your Transaction is Already Processed!';
    public static EXPIRED = 'Sorry Your Transaction is Expired!';
}
